<div *ngIf="arrival && arrival.arrive_packing_lists"><div *ngFor="let apl of arrival.arrive_packing_lists | filterBy: 'empty' : false
            | filterBy: 'empty' : false
            | filterBy: 'isValid' : display_valids
            | filterBy: 'deflected': display_deflected
            | filterBy: 'client_id': filter.client_id 
            | sortBy: 'sort_index' : ''+wpid; let i = index"><app-inventory-packing-list [pl]="apl" [compact]="compact"></app-inventory-packing-list></div></div>